import { List, Map } from 'immutable'
import { createSelector } from 'reselect'

import { getEditingOrganizationFromRouter } from 'store/entities/organizations/selectors'
import { IIdentityOrganizationRecord } from '../identity/interface'

export const getReviewsSurveys = (state: Map<string, { reviewsSurveys: Map<string, any> }>) =>
  // @ts-ignore
  state.get('persist').reviewsSurveys

export const getReviewsSurveysList = createSelector(
  getReviewsSurveys,
  (reviewsSurveys): List<any> => {
    return reviewsSurveys.get('list')
  }
)

export const getReviewsSurveyById = (reviewsSurveyId: string | number) =>
  createSelector(
    getReviewsSurveysList,
    (list): Map<string, any> => {
      return list.find((reviewsSurvey: Map<string, any>) => {
        let surveyId = reviewsSurveyId
        if (typeof reviewsSurveyId === 'string') {
          surveyId = parseInt(reviewsSurveyId)
        }
        return reviewsSurvey.get('id') === surveyId
      })
    }
  )

const getPublishedReviewsSurveysList = createSelector(getReviewsSurveysList, list => {
  return list.filter(reviewsSurvey => reviewsSurvey.get('isPublished'))
})

export const getPublishedReviewsSurveysListForSelect = createSelector(
  [getPublishedReviewsSurveysList, getEditingOrganizationFromRouter],
  (list, organization: IIdentityOrganizationRecord) => {
    const listForSelect = list.reduce((acc: List<any>, reviewsSurvey: Map<string, any>) => {
      // show only published survey and editing organization's survey
      if (!reviewsSurvey.get('organizationId') || reviewsSurvey.get('organizationId') === organization.get('id')) {
        return acc.push({
          label: reviewsSurvey.get('name'),
          value: reviewsSurvey.get('id'),
        })
      }
      return acc
    }, List())
    return listForSelect.unshift({ label: 'Not Selected', value: null })
  }
)

const getReviewsSurveysAsking = createSelector(
  getReviewsSurveys,
  (reviewsSurveys): Map<string, any> => {
    return reviewsSurveys.get('asking')
  }
)

export const getAskingSurvey = createSelector(getReviewsSurveysAsking, asking => asking.get('survey'))
